import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { IGetCnpjInfoResponse } from '../models/cnpj-info.model';

@Injectable({
  providedIn: 'root'
})
export class CnpjInfoService {

  baseUrl: string = 'https://publica.cnpj.ws/cnpj';

  constructor(private http: HttpClient) { }

  getCnpjInfo(cnpj: string) : Promise<IGetCnpjInfoResponse> {
    return new Promise((resolve, reject) => {
      this.http.get<any>(`${this.baseUrl}/${cnpj}`)
      .subscribe(
        (response: any) => {
          resolve(response);
        },
        (error) => {
          var status: string = error.error?.status;
          var errorDetails = error.error?.detalhes;
          var title: string = error.error?.titulo;
          if(title === "Muitas requisições"){
            errorDetails = "Muitas requisições, aguarde um minuto e tente novamente";
          }
          resolve({
            status: status,
            titulo: errorDetails
          });
        }
      );
    });
  }
}
